import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { DeleteVacancyError } from '../../errors';
import { ESubdomain } from '../../constants/domain';
import {
  fetchDeleteVacancy,
  IDeleteVacancyResponse200,
  IDeleteVacancyResponse400,
} from '../../repositories/vacancies/v1/delete-vacancy';

export interface IDeleteVacancyDependencies {
  httpApi: IHttpApi;
  logger: ILogger;
  subdomain: ESubdomain;
}

export interface IDeleteVacancyParams {
  vacancyId: number;
}

export const deleteVacancy = async (deps: IDeleteVacancyDependencies, params: IDeleteVacancyParams) => {
  const { httpApi, logger, subdomain } = deps;
  const { vacancyId } = params;

  try {
    const resp = await fetchDeleteVacancy<IDeleteVacancyResponse200, IDeleteVacancyResponse400>({
      httpApi,
      parameters: {
        id: vacancyId,
      },
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/x-www-form-urlencoded']],
        },
      },
    });

    if (resp.statusCode !== 200) {
      throw new DeleteVacancyError({
        subdomain,
        message: resp.response.message,
        details: {
          error: JSON.stringify(resp.response.errors),
        },
      });
    }
  } catch (e) {
    logger.error(e);
  }
};
